import { useSelector } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { ApplicationState } from '@mews-commander/types';

export const useFormValueSelector = <T extends object>(formName: string, fieldName: keyof T) =>
    useSelector((state: ApplicationState) => formValueSelector(formName)(state, fieldName.toString()));
